<template>
  <span
      class="layer-glyph"
      :style="glyphStyle"
      v-html="markup"
  />
</template>

<script>
import { getLayerGlyph } from './layerIcons';

export default {
  name:  'LayerIcon',
  props: {
    name: {
      type:     String,
      required: true,
    },
    size: {
      type:    Number,
      default: 15,
    },
  },
  computed: {
    markup() {
      return getLayerGlyph(this.name);
    },
    glyphStyle() {
      return {
        width:  `${this.size}px`,
        height: `${this.size}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.layer-glyph {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  color: inherit;
  line-height: 0;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
